/** Must match backend tenants.berlin_stock_import.ALLOWED_SOURCE_SCHEMAS */
export const BERLIN_IMPORT_SOURCE_SCHEMAS = ["mobile", "parts"];

export const BERLIN_IMPORT_SOURCE_SCHEMA_OPTIONS = [
  { label: "Mobile", value: "mobile" },
  { label: "Parts", value: "parts" },
];

export const normalizeBerlinImportPayload = ({
  invoice_id,
  source_schema,
  batch_id,
}) => {
  const normalizedSchema = String(source_schema || "")
    .trim()
    .toLowerCase();

  if (!BERLIN_IMPORT_SOURCE_SCHEMAS.includes(normalizedSchema)) {
    throw new Error("Source schema must be mobile or parts.");
  }

  const normalizedBatchId = Number(batch_id);
  if (!Number.isInteger(normalizedBatchId) || normalizedBatchId <= 0) {
    throw new Error("A valid batch is required.");
  }

  const normalizedInvoiceId = String(invoice_id || "").trim();
  if (!normalizedInvoiceId) {
    throw new Error("Invoice ID is required.");
  }

  return {
    invoice_id: normalizedInvoiceId,
    source_schema: normalizedSchema,
    batch_id: normalizedBatchId,
  };
};
